module.exports = __webpack_public_path__ + "img/male_S_02.34d44f36.png";